import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NForm = _resolveComponent("NForm")!

  return (_openBlock(), _createBlock(_component_NForm, {
    ref: "form",
    layout: _ctx.layout,
    model: _ctx.model,
    state: _ctx.state,
    disabled: _ctx.disabled
  }, null, 8, ["layout", "model", "state", "disabled"]))
}